import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Pressable, Text, useTheme } from "native-base";
import { Path, Svg } from "react-native-svg";
import { useTranslation } from "@madmedical/i18n";
import Avatar from "../../atoms/Avatar/Avatar";
const ProfileItem = ({ profile, userId, onPress, isTrigger, propStyles, }) => {
    const { colors } = useTheme();
    const { t } = useTranslation();
    const styles = {
        slot: {
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: 8,
            paddingRight: 8,
        },
        svg: {
            flexShrink: 0,
        },
        text: {
            flex: 1,
            marginRight: 8,
        },
        name: {
            color: colors.black,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
        trustee: {
            fontSize: 12,
            color: "#4E4E4E", // not available in Theme colors
        },
    };
    return (_jsxs(Pressable, Object.assign({ onPress: onPress, style: Object.assign(Object.assign({}, styles.slot), propStyles), flexDirection: "row", alignItems: "center" }, { children: [_jsx(Avatar, { source: profile === null || profile === void 0 ? void 0 : profile.avatarUrl, initials: profile === null || profile === void 0 ? void 0 : profile.initials, size: "lg" }), _jsxs(Box, Object.assign({ style: styles.text }, { children: [_jsx(Text, Object.assign({ style: styles.name, fontWeight: "500", overflow: "hidden" }, { children: profile === null || profile === void 0 ? void 0 : profile.fullName })), _jsx(Text, Object.assign({ style: styles.trustee }, { children: (profile === null || profile === void 0 ? void 0 : profile.userId) === userId
                            ? t("ownAccount")
                            : t("authorizedPersonsAccount") }))] })), isTrigger && (_jsx(Svg, Object.assign({ style: styles.svg, width: "32", height: "38", viewBox: "0 0 32 38", fill: "none" }, { children: _jsx(Path, { d: "M16 22.025L11.1875 17.2125L12.15 16.25L16 20.1L19.85 16.25L20.8125 17.2125L16 22.025Z", fill: colors.gray[800], stroke: colors.gray[800], strokeWidth: "0.3" }) })))] })));
};
export default ProfileItem;
